// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-748ac528] .p-treetable .p-treetable-tbody > tr > td {\n  padding: 0.2rem 0.2rem !important;\n}", ""]);
// Exports
module.exports = exports;
